import { hasPermission } from "../../Config/permissions.js";

export const canAdminPerformUserAction = (user, permissionKey) =>
  Boolean(
    user?.Type === "Admin" &&
      permissionKey &&
      hasPermission(user, permissionKey),
  );
